<template>
  <path
    opacity="0.1"
    d="M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z"
    fill="#3769D6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M30 20C30 25.5228 25.5228 30 20 30C14.4772 30 10 25.5228 10 20C10 14.4772 14.4772 10 20 10C25.5228 10 30 14.4772 30 20ZM24.1667 18.1125C24.1667 17.9468 24.0324 17.8125 23.8667 17.8125H16.1333C15.9676 17.8125 15.8333 17.9468 15.8333 18.1125V21.8875C15.8333 22.0532 15.9676 22.1875 16.1333 22.1875H23.8667C24.0324 22.1875 24.1667 22.0532 24.1667 21.8875V18.1125ZM14.25 15.625C13.9739 15.625 13.75 15.8489 13.75 16.125V23.875C13.75 24.1511 13.9739 24.375 14.25 24.375H25.75C26.0261 24.375 26.25 24.1511 26.25 23.875V16.125C26.25 15.8489 26.0261 15.625 25.75 15.625H14.25ZM20 21.25C20.6904 21.25 21.25 20.6904 21.25 20C21.25 19.3096 20.6904 18.75 20 18.75C19.3096 18.75 18.75 19.3096 18.75 20C18.75 20.6904 19.3096 21.25 20 21.25Z"
    fill="#3769D6"
  />
</template>
